import { useCallback } from "react";

import { getRowMove } from "../utils/rowOrder";

// The task list is not rebuilt on a save, so the row moves through the library's own action
const useGanttRowOrder = ({ ganttApi, tasks }) =>
	useCallback(
		(serviceId) => {
			if (!ganttApi || !Array.isArray(tasks)) return;

			// serviceData is the record applyServiceScheduledDate patches in place,
			// so it carries the saved date without the task list being rebuilt
			const moved = tasks.find((task) => task.serviceData?.id === serviceId);
			if (!moved) return;

			const move = getRowMove(
				tasks.filter((task) => task.parent === moved.parent),
				moved.id,
			);
			if (move) ganttApi.exec("move-task", move);
		},
		[ganttApi, tasks],
	);

export default useGanttRowOrder;
